if (!customElements.get("variant-picker")) {
  class VariantPicker extends HTMLElement {
    constructor() {
      super();

      this.setEngravingCharCount();
      this.setPropertyStates();
    }

    get selectedOptionValues() {
      const options = this.querySelectorAll(
        "select, .variant-picker__field input[type='radio']"
      );
      const selectedValues = new Map();

      options.forEach((field) => {
        const fieldName = field.name || field.dataset.fieldName;

        if (field.tagName.toLowerCase() === "select") {
          const selectedOption = Array.from(field.options).find(
            (opt) => opt.selected && !opt.disabled
          );
          if (selectedOption) {
            selectedValues.set(fieldName, selectedOption.dataset.optionValueId);
          }
        } else if (
          field.tagName.toLowerCase() === "input" &&
          field.type === "radio"
        ) {
          const checkedInput = field.checked ? field : null;
          if (checkedInput) {
            selectedValues.set(fieldName, checkedInput.dataset.optionValueId);
          }
        }
      });

      options.forEach((field) => {
        const fieldName = field.name || field.dataset.fieldName;

        if (!selectedValues.has(fieldName)) {
          if (field.tagName.toLowerCase() === "select") {
            const firstValidOption = Array.from(field.options).find(
              (opt) => !opt.disabled
            );
            if (firstValidOption) {
              selectedValues.set(
                fieldName,
                firstValidOption.dataset.optionValueId
              );
            }
          } else if (
            field.tagName.toLowerCase() === "input" &&
            field.type === "radio"
          ) {
            const firstInput = field;
            if (firstInput) {
              selectedValues.set(fieldName, firstInput.dataset.optionValueId);
            }
          }
        }
      });

      const result = [];
      options.forEach((field) => {
        const fieldName = field.name || field.dataset.fieldName;
        if (selectedValues.has(fieldName)) {
          const optionValueId = selectedValues.get(fieldName);
          if (optionValueId && !result.includes(optionValueId)) {
            result.push(optionValueId);
          }
        }
      });
      return result;
    }

    getInputForEventTarget(target) {
      return target.tagName === "SELECT" ? target.selectedOptions[0] : target;
    }

    connectedCallback() {
      this.addEventListener("change", (event) => {
        const target = this.getInputForEventTarget(event.target);

        this.handleEngraving(event);


        window.FoxThemeEvents.emit(PUB_SUB_EVENTS.optionValueSelectionChange, {
          data: {
            event,
            target,
            selectedOptionValues: this.selectedOptionValues,
          },
        });
      });
    }

    handleEngraving(event) {
      const engravingInput = document.querySelector(".variant-picker__field select[name='options[ENGRAVING]'], .variant-picker__field select[name='options[Engraving]'], .variant-picker__field select[name='options[HAND ENGRAVING]'], .variant-picker__field select[name='options[Hand Engraving]']");
      const variantPickerBlock = document.querySelector(".variant-picker");

      if (engravingInput) {
        const engravingValue = engravingInput.value;
        if (engravingValue && engravingValue !== "No Engraving") {
          variantPickerBlock.classList.add("valid-engraving-selected");

          this.setEngravingCharCount();
        } else {
          const noEngravingStyleInput = document.querySelector(".variant-picker__field[data-option-name='ENGRAVING STYLE'] input[value='No Engraving']");
          if (noEngravingStyleInput) {
            noEngravingStyleInput.checked = true;
          }
          variantPickerBlock.classList.remove("valid-engraving-selected");
        }

        this.setPropertyStates();
      }
    }

    setEngravingCharCount() {
      const engravingInput = document.querySelector(".variant-picker__field select[name='options[ENGRAVING]'], .variant-picker__field select[name='options[Engraving]'], .variant-picker__field select[name='options[HAND ENGRAVING]'], .variant-picker__field select[name='options[Hand Engraving]']");
      if (!engravingInput) {
        return;
      }

      const engravingValue = engravingInput.value;

      let minCharCount = 1; 
      let maxCharCount = 10;

      const hasDash = engravingValue.includes("-");
      if (hasDash) {
        const match = engravingValue.match(/(\d+)-(\d+)/);
        if (match) {
          minCharCount = parseInt(match[1]);
          maxCharCount = parseInt(match[2]);
        }
      } else {
        const number = engravingValue.match(/\d+/);
        if (number) {
          minCharCount = parseInt(number[0]);
          maxCharCount = parseInt(number[0]);
        }
      }

      const charactersInput = document.querySelector("input[name='properties[Engraving Characters]']");
      if (charactersInput) {
        // unset then set
        charactersInput.removeAttribute('minlength');
        charactersInput.removeAttribute('maxlength');

        charactersInput.minLength = minCharCount;
        charactersInput.maxLength = maxCharCount;
      }
    }

    setPropertyStates() {
      const variantPickerBlock = document.querySelector(".variant-picker.valid-engraving-selected");
      const charactersInput = document.querySelector("input[name='properties[Engraving Characters]']");
      const fontInputs = document.querySelectorAll("input[name='properties[Engraving Font]']");

      // [hidden] attribute is what the validation checks against
      if (!variantPickerBlock) {
        if (charactersInput) {
          charactersInput.value = "";
          charactersInput.setAttribute('hidden', "");
        }
        fontInputs.forEach(input => {
          if (input.checked) {
            input.checked = false;
          }
          input.setAttribute('hidden', "");
        });
      } else {
        if (charactersInput) {
          charactersInput.removeAttribute('hidden');
        }
        fontInputs.forEach(input => {
          input.removeAttribute('hidden');
        });
      }
    }
  }

  customElements.define("variant-picker", VariantPicker);
}
